import { render, staticRenderFns } from "./POIRoute.vue?vue&type=template&id=d2d3004e"
import script from "./POIRoute.js?vue&type=script&lang=js&external"
export * from "./POIRoute.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports